import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, createBaseQuery } from '../base/baseApi';

export const adminApi = createApi({
    tagTypes: ['Admin'],
    reducerPath: 'adminApi',
    baseQuery: createBaseQuery({ baseUrl: `${API_BASE_URL}/admin` }),
    endpoints: (builder) => ({
        fetchData: builder.query({
            query: () => ({
                url: '/fetch-data',
                method: 'GET',
            }),
            providesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        refreshData: builder.query({
            query: () => ({
                url: '/refresh-data',
                method: 'GET',
            }),
            providesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        viewclient: builder.query({
            query: (clientId) => ({
                url: `/users/view/${clientId}`,
                method: 'GET',
            }),
            providesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        editClient: builder.mutation({
            query: ({ ID, ...data }) => ({
                url: `/users/update/${ID}`,
                method: 'PUT',
                body: data,
            }),
            providesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        activateClient: builder.mutation({
            query: (clientId) => ({
                url: `/users/activate/${clientId}`,
                method: 'PUT',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        deactivateClient: builder.mutation({
            query: (clientId) => ({
                url: `/users/deactivate/${clientId}`,
                method: 'PUT',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        upgradeClient: builder.mutation({
            query: (clientId) => ({
                url: `/users/upgrade/${clientId}`,
                method: 'PUT',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        downgradeClient: builder.mutation({
            query: (clientId) => ({
                url: `/users/downgrade/${clientId}`,
                method: 'PUT',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        deleteClient: builder.mutation({
            query: (clientId) => ({
                url: `/users/delete/${clientId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        createModerator: builder.mutation({
            query: (data) => ({
                url: '/moderators/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        editModerator: builder.mutation({
            query: ({ ID, ...data }) => ({
                url: `/moderators/update/${ID}`,
                method: 'PUT',
                body: data,
            }),
            providesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        deleteModerator: builder.mutation({
            query: (moderatorId) => ({
                url: `/moderators/delete/${moderatorId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        createAdmin: builder.mutation({
            query: (data) => ({
                url: '/admins/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        editAdmin: builder.mutation({
            query: ({ ID, ...data }) => ({
                url: `/admins/update/${ID}`,
                method: 'PUT',
                body: data,
            }),
            providesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
        deleteAdmin: builder.mutation({
            query: (adminId) => ({
                url: `/admins/delete/${adminId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Admin'],
            transformResponse: (response) => response.Data,
        }),
    }),
});

export const {
    useFetchDataQuery,
    useLazyRefreshDataQuery,
    useViewclientQuery,
    useEditClientMutation,
    useActivateClientMutation,
    useDeactivateClientMutation,
    useUpgradeClientMutation,
    useDowngradeClientMutation,
    useDeleteClientMutation,
    useCreateModeratorMutation,
    useEditModeratorMutation,
    useDeleteModeratorMutation,
    useCreateAdminMutation,
    useEditAdminMutation,
    useDeleteAdminMutation,
} = adminApi;